<template>
    <div class="rili">
        <div class="news_box">
            <div class="news_title">
                <div class="left">活动日历</div>
                <div class="more" @click="showList">更多></div>
            </div>

            <div class="news_content" v-if="active.meetingName" @click="showMeetingDetail( active )">
                <div class="img_box">
                    <img :src="active.meetingImg" v-if="active.meetingImg && active.meetingImg.indexOf('http') != -1" alt="">
                    <img :src="$ImgUrl + active.meetingImg" v-if="active.meetingImg && active.meetingImg.indexOf('http') == -1" alt="">
                    <img src="../../assets/static/index/default.png" v-if="!active.meetingImg" alt="">
                </div>
                <div class="info_box">
                    <div class="title">
                        {{ active.meetingName }}
                    </div>
                    <div class="dept">
                         {{ active.deptName }}
                    </div>
                    <div class="time desc">
                        <span class="iconfont icon-shijian"></span>时间: {{ active.startTime }}
                    </div>
                    <div class="address desc">
                        <span class="el-icon-location-outline"></span>地点: {{ active.meetingAddress }}
                    </div>
                    <div class="prople desc">
                        <span class="el-icon-user"></span>参会人数: {{ active.count }}
                    </div>
                    <div class="status-line">
                        <div class="status_left">
                            <span class="iconfont icon-yijieshu"></span> <span>{{ active.meetingStatusName }}</span>
                        </div>
                        <div class="show_info">
                            <span>查看详情 ></span>
                        </div>
                    </div>
        
                </div>
            </div>
            <div class="no_data" v-else>
                <img src="../../assets/static/index/nomore.png" alt="">
            </div>
        </div>
        <div class="rili_box">
            <Calendar
                v-on:choseDay="clickDay"
                v-on:changeMonth="changeDate"
                :markDateMore='markData'
            
                ></Calendar>
        </div>
        <div class="icon_box">
            <img src="../../assets/static/index/riliicon.png" alt="">
            <img src="../../assets/static/index/riliicon.png" alt="">
        </div>

    </div>
</template>

<script>
import Calendar from 'vue-calendar-component';
    export default {
        components: {
            Calendar,
        },
        data() {
            return {
                markData: [ 

                ], // 日历标记数据,
                list: [],
                active: {},
                monthStr: "",
                ReqUrl: "",
            }
        },
        mounted () {
            this.getListByDate();
        },
        watch: {
            deptId () {
                this.getListByDate()
            }
        },
        computed: {
            deptId () {
                return Number(this.$route.params.id ) ?  Number(this.$route.params.id) : 0
            },
            token () {
                return this.$store.getters.token
            }
        },
        methods: {
            // 会议详情
            showMeetingDetail ( item ) {
                // console.log( item )
                    this.$router.push(`/MeetingDetail/${ item.meetingId }`) 
            },
            async clickDay(data) {
                // console.log(data); //选中某天
                let dateStr = data.replace(/\//g,"-")
                let res = await this.$axios.post("/lencon/pc/activity/getActivityByDay", { day: dateStr, deptId: this.deptId })
                if ( res.data.code == 1 ) {
                    this.active = res.data.data
                } else {
                    this.active = {}
                }

            },
            changeDate(data) {
                // console.log(data); //左右点击切换月份
                let dateArr = data.split("/")
                let monthStr = `${dateArr[0]}-${dateArr[1].padStart(2,'0')}`
                this.markData = []
                let url = "/lencon/pc/activity/getActivityByMonth"
                this.getListByDate( url, { deptId: this.deptId, month: monthStr } )
            },

            // 会议列表
            showList () {
                this.$router.push("/MeetingShow")
            },

            // 获取日历活动列表
            async getListByDate ( url, data ) {
                this.markData = []
                let reqUrl = url ? url : "/lencon/pc/activity/calendar"
                let obj = data ? data : { deptId: this.deptId }
                let res = await this.$axios.post( reqUrl, obj)
                if ( res.data.code == 1 ) {
                    if ( res.data.data ) {
                        this.active = res.data.data
                    }
                    let arr =  res.data.currentMonth
                    console.log( arr )
                    let lastDay = ""
                    if ( res.data.selectDay ) {
                         lastDay = res.data.selectDay.split(" ")
                    }
                
                    
                    if ( arr.length > 0 ) {
                        arr.forEach( el => {
                            let dateStr = el.replace(/-/g, "/")
                            let cls = "hasMeeting"
                            if ( lastDay ) {
                                let cls = dateStr == lastDay[0].replace("-","/") ? 'lastDay' : 'hasMeeting'
                            } 
                            
                            this.markData.push({
                                date: dateStr,
                                className: cls
                            })
                        })
                    }
                }
            }
        }
    }
</script>


<style>
.hasMeeting {
    background: #2767c4  !important;
    color: #ffffff !important;
    border-radius: 50%;
    overflow: hidden;
}
.lastDay {
    background: green !important;
    border-radius: 50%;
}
.wh_content_all {
    background-color: #fff !important;
    color: #000 !important;
}
.wh_content_item {
    color: #000 !important;
}
.wh_top_changge {
    background: #FFEDED !important;
    
}
.wh_content_li {
    color: #000 !important;
}
.wh_jiantou1 {
    border-color: #000 !important;
}
.wh_jiantou2 {
    border-color: #000 !important;
}
.wh_isToday {
    background: #F8B257 !important;
    color: #fff !important;
}
@media screen and (min-width: 460px) {
    .wh_item_date:hover {
        border-radius: 50% !important;
    }
}

</style>

<style lang="scss" scoped>


.rili {
    width: 1200px;
    margin: 60px auto;
    display: flex;
    justify-content: space-between;
    position: relative;
    left: 0;
    top: 0;
    .news_box {
        width: 880px;
        height: 330px;background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        padding: 30px;
        box-sizing: border-box;
        .news_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 10px;
            border-bottom: 1px solid #2767c4 ;
            .left {
                font-size: 24px;
                font-weight: bold;
                color: #2767c4 ;
            }
            .more {
                font-size: 14px;
                color: #b3b3b3;
                cursor: pointer;
            }
        }
        .no_data {
            width: 100%;
            text-align: center;
            line-height: 330px;
            img {
                width: 200px;
                height: 150px;
                
            }
        }
        .news_content {
            margin-top: 20px;
            display: flex;
            cursor: pointer;
            .img_box {
                width: 275px;
                height: 195px;
                img {
                    width: 275px;
                    height: 195px;
                }
            }
            .info_box {
                margin-left: 20px;
                flex: 1;
                .title {
                    font-size: 18px;
                    font-weight: bold;
                }
                .dept {
                    font-size: 16px;
                    color: #828181;
                    line-height: 40px;
                }
                .desc {
                    font-size: 14px;
                    color: #8e8e8e;
                    line-height: 30px;
                    span {
                        margin-right: 10px;
                    }
                }
                .status-line {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-right: 50px;
                    padding: 10px 0;
                    font-size: 14px;
                    border-top: 1px solid #ebeaea;
                    border-bottom: 1px solid #ebeaea;
                    .status_left {
                        color: #2767c4 ;
                    }
                    .show_info {
                        color: #8e8e8e;
                    }
                }
            }
        }
    }
    .rili_box {
        width: 310px;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
    }
    .icon_box {
        position: absolute;
        left: 860px;
        top: 100px;
        height: 150px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        img {
            display: block;

        }
    }
}
</style>